import React, { useState, ReactNode, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Row,
  Col,
  Form,
  Upload,
  Input,
  InputNumber,
  Slider,
  Button,
  Popover,
  Divider,
  message as Message,
  Checkbox,
} from 'antd';
import moment from 'moment';
import { SliderValue } from 'antd/lib/slider';
import DayPicker, { DayModifiers } from 'react-day-picker';
import { FaArrowLeft } from 'react-icons/fa';
import { IoMdArrowDropleft, IoMdArrowDropright } from 'react-icons/io';
import classnames from 'classnames';
import _ from 'lodash';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import Resizer from 'react-image-file-resizer';
import { useLocation } from 'react-router-dom';
import {
  RestrictionsMenu,
  RestrictionContext,
  resetRestriction,
} from '../dashboard/components/Restrictions';
import { Consumption } from './EditFilter';
import { Category } from './components/ProductCategory';
import { PageHeader } from '../layout/PageHeader';
import { getBase64, UploadPhotoContent } from '../profile/CreateProfile';

import { MealEdit } from '../../store/meals/actions';
import { getAppGlobalState } from '../../store/app-globals/selectors';
import { setError, setLoading } from '../../store/app-globals/actions';
import { StableOfferState } from './AddMeals';
import { colors } from '../../constants/colors';
import { fnCheckForRestrictedWords } from '../../constants/resctrictedWords';

const EAT_WITH = 'Eat with';
const BOTH = 'Both';
const EAT_WITH_DESCRIPTION =
  'Food is available for Eat with, which means the guest has to consume the food at the cooks place.';

export interface Time {
  id: number;
  title: string;
  active: boolean;
  time: string;
}

export interface ScheduleProps {
  date?: Date;
  time?: string[];
}

export interface TimeProps {
  day?: Date;
  done: (date: Date | undefined, time: string[]) => void;
}

export interface TimeScheduleContextProps {
  time: Time[];
}

export interface DateSelectionProps {
  scheduleValues: ScheduleProps[] | undefined;
  onClick: (schedule: ScheduleProps[] | undefined) => void;
}

export interface MealProps {
  state: any;
}

const time = [
  { id: 0, title: 'a.m', active: false, time: '7 AM – 11 AM' },
  { id: 0, title: 'p.m', active: false, time: '11 AM – 17 PM' },
  { id: 0, title: 'Evening', active: false, time: '17 AM – 23 PM' },
];

export const TImeScheduleContext = React.createContext<
  TimeScheduleContextProps
>({ time });
export const PopoverContent: React.FC<TimeProps> = ({ day, done }) => {
  const { time } = React.useContext(TImeScheduleContext);
  const [scheduleTime, setScheduleTime] = useState(time);

  const handButtonCLick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const handleButtonClick = (i: number) => (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    const newSchedule = Object.assign({}, scheduleTime);
    newSchedule[i].active = !newSchedule[i].active;
    setScheduleTime(Object.values(newSchedule));
  };

  const handleDoneButton = () => {
    const activeItems = scheduleTime.filter(i => i.active).map(i => i.title);
    done(day, activeItems);
    const resetState = time.map(i => {
      i.active = false;
      return i;
    });
    setScheduleTime(resetState);
  };

  return (
    <div className="popover-container" onClick={handButtonCLick}>
      <div>
        <span className="popover-date">
          {`${moment(day).format('Do')}
            ${i18next.t(moment(day).format('MMMM'))}`}
        </span>
        {scheduleTime.map((item, i) => {
          const btnClass = classnames({
            'popover-items': true,
            'popover-items-active': item.active,
          });
          return (
            <div key={i} className={btnClass} onClick={handleButtonClick(i)}>
              <span>{item.title}</span>
              <span>{item.time}</span>
            </div>
          );
        })}
      </div>
      <div className="done-button">
        <Button type="link" onClick={handleDoneButton}>
          Done
        </Button>
      </div>
    </div>
  );
};

const Weekday = (props: any) => {
  const { t } = useTranslation();
  let renderDay = '';
  switch (props.weekday) {
    case 0:
      renderDay = t('Su');
      break;
    case 1:
      renderDay = t('Mo');
      break;
    case 2:
      renderDay = t('Tu');
      break;
    case 3:
      renderDay = t('We');
      break;
    case 4:
      renderDay = t('Th');
      break;
    case 5:
      renderDay = t('Fr');
      break;
    case 6:
      renderDay = t('Sa');
      break;
    default:
      break;
  }
  return (
    <div className={props.className}>
      <span>{renderDay}</span>
    </div>
  );
};

export const DateSelection: React.FC<DateSelectionProps> = ({
  scheduleValues,
  onClick,
}) => {
  const [day, setDay] = useState<Date>();
  const [selectedDays, setSelectedDays] = useState<(Date | undefined)[]>();
  const [schedule, setSchedule] = useState<ScheduleProps[] | undefined>([]);
  const [visible, setVisible] = useState(false);
  const [datepickerVisible, setdatepickerVisible] = useState(false);
  const [scheduleTime, setScheduleTime] = useState(time);
  const today = new Date();
  const year = today.getFullYear();
  const { t } = useTranslation();
  moment.locale('en');

  const handleDatePickerClick = () => {
    setSchedule(scheduleValues);
    setdatepickerVisible(true);
  };

  const handleBackPress = () => {
    setdatepickerVisible(false);
    setSchedule([]);
    setSelectedDays([]);
  };

  const handleDoneButton = () => {
    setdatepickerVisible(false);
    onClick(schedule);
  };

  const handleDayClick = (day: Date) => {
    const temp = schedule?.filter(v => moment(v.date).isSame(day));
    if (temp) {
      const tempTime = scheduleTime.map(s => {
        if (temp && temp[0] && temp[0].time && temp[0].time.includes(s.title)) {
          s.active = true;
        } else {
          s.active = false;
        }
        return s;
      });
      setScheduleTime(tempTime);
    }
    setVisible(true);
    setDay(day);
  };

  const handleScheduleChanges = (date: Date | undefined, time: string[]) => {
    let temp: ScheduleProps[] | undefined = [];
    const selectedIndex =
      schedule &&
      schedule.findIndex(s => {
        if (s.date && day) {
          const index = moment(s.date).isSame(day);
          return index;
        }
        return -1;
      });

    if (selectedIndex === -1 && time.length) {
      temp = schedule && schedule.concat({ date, time });
      setSchedule(temp);
    } else if (
      (selectedIndex === 0 || (selectedIndex && selectedIndex > -1)) &&
      time.length === 0
    ) {
      temp =
        schedule &&
        schedule.filter((value: any, i: number) => {
          return i !== selectedIndex;
        });
      setSchedule(temp);
    } else if (
      (selectedIndex === 0 || (selectedIndex && selectedIndex > -1)) &&
      time.length !== 0
    ) {
      temp =
        schedule &&
        schedule.filter((value: any, i: number) => {
          return i !== selectedIndex;
        });
      temp = temp && temp.concat({ date, time });
      setSchedule(temp);
    }
    setVisible(false);
  };

  const validatSchedule = () => {
    const dates =
      schedule &&
      schedule.map(s => {
        if (s.time && s.time.length) {
          return s.date;
        }
        return s.date; // remove if error
      });
    setSelectedDays(dates);
  };

  const renderDay = (date: Date, modifiers: DayModifiers): ReactNode => {
    const customDate = new Date(date).getDate();
    return (
      <Popover
        key={customDate}
        visible={visible && customDate === moment(day).date()}
        content={<PopoverContent day={day} done={handleScheduleChanges} />}
        trigger="click"
      >
        <div>{customDate}</div>
      </Popover>
    );
  };

  const RenderNavButtons = (props: any) => {
    return (
      <div className={props.className}>
        <Row justify="space-between">
          <div style={{ position: 'absolute', top: 0, right: 0 }}>
            <Button>
              <IoMdArrowDropleft
                onClick={() => props.onPreviousClick()}
                style={{ cursor: 'pointer' }}
                size={24}
              />
            </Button>
            <Button>
              <IoMdArrowDropright
                onClick={() => props.onNextClick()}
                style={{ cursor: 'pointer' }}
                size={24}
              />
            </Button>
          </div>
        </Row>
      </div>
    );
  };

  const arrayHeaderMonths = [
    t('January'),
    t('February'),
    t('March'),
    t('April'),
    t('May'),
    t('June'),
    t('July'),
    t('August'),
    t('September'),
    t('October'),
    t('November'),
    t('December'),
  ];
  const content = (
    <div className="popover-datepicker">
      <div className="popover-actions">
        <Button
          type="link"
          className="popover-actions-icon"
          onClick={handleBackPress}
        >
          <FaArrowLeft color="#B4B4B4" size={17} />
        </Button>
        <Button type="link" onClick={handleDoneButton}>
          {t('Done')}
        </Button>
      </div>
      <Divider />
      <DayPicker
        selectedDays={selectedDays}
        disabledDays={{ before: today }}
        toMonth={new Date(year, 11)}
        onDayClick={handleDayClick}
        renderDay={renderDay}
        className="date-picker-container"
        navbarElement={<RenderNavButtons />}
        weekdayElement={<Weekday />}
        months={arrayHeaderMonths}
      />
    </div>
  );

  useEffect(validatSchedule, [schedule]);
  return (
    <TImeScheduleContext.Provider value={{ time: scheduleTime }}>
      <div className="restrictions-wrapper datepicker-container">
        <div className="form-label">{t('Date and Time')}</div>
        <Popover
          visible={datepickerVisible}
          content={content}
          trigger="click"
          placement="bottomLeft"
        >
          <Button
            shape="round"
            className="filter-buttons"
            onClick={handleDatePickerClick}
          >
            {t('Date and Time')}
          </Button>
        </Popover>
      </div>
    </TImeScheduleContext.Provider>
  );
};

export const EditMeals: React.FC = () => {
  const location = useLocation();
  const { state } = location;
  const mealState: MealProps = {
    state,
  };
  const { isLoading, message, hasError } = useSelector(getAppGlobalState);
  const [disabled, setDiasbled] = useState(false);
  const [image, setImage] = useState(mealState.state.image);
  const [restrictionValues, setRestrictionValues] = useState<string[]>([]);
  const [sliderValue, setSliderValue] = useState<number | [number, number]>(
    mealState.state.maxtime
  );
  const { restriction } = React.useContext(RestrictionContext);
  const [category, setCategory] = useState<string[]>([]);
  const [scheduleValues, setscheduleValues] = useState<
    ScheduleProps[] | undefined
  >([]);
  const [consumption, setConsumption] = useState(mealState.state.consumption);
  const [portions, setPortions] = useState<number>(mealState.state.portions);
  const [isChecked, setCheckStable] = useState<boolean>(false);
  const [isPopup, setPopup] = useState<boolean>(false);
  const [stableOffer, setStableOffer] = useState<StableOfferState>({
    isChecked: false,
    time: [],
  });
  const { time } = React.useContext(TImeScheduleContext);
  const year = new Date().getFullYear();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { t } = useTranslation();

  const [scheduleTime, setScheduleTime] = useState(time);

  const [fields] = useState([
    {
      name: ['title'],
      value: mealState.state.title,
    },
    {
      name: ['description'],
      value: mealState.state.description,
    },
  ]);

  const handleDoneStableOffer = () => {
    const activeItems = scheduleTime.filter(i => i.active).map(i => i.title);
    setStableOffer({
      isChecked,
      time: activeItems,
    });
    setPopup(false);
  };

  const handleTimeButtonClick = (i: number) => (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    const newSchedule = Object.assign({}, scheduleTime);
    newSchedule[i].active = !newSchedule[i].active;
    setScheduleTime(Object.values(newSchedule));
  };

  const PopoverStableOfferContent = (
    <div className="popover-container">
      <div>
        {scheduleTime.map((item, i) => {
          const btnClass = classnames({
            'popover-items': true,
            'popover-items-active': item.active,
          });
          return (
            <div
              key={i}
              className={btnClass}
              onClick={handleTimeButtonClick(i)}
            >
              <span>{t(item.title)}</span>
              <span>{item.time}</span>
            </div>
          );
        })}
      </div>
      <div className="done-button">
        <Button type="link" onClick={handleDoneStableOffer}>
          Done
        </Button>
      </div>
    </div>
  );

  const normFile = (e: any): void => {
    // const maxsize = 400;
    // if (e.file.size / 1000 > maxsize) {
    //   setImage('');
    //   alert('image should be have 400kb max size');
    //   return;
    // }
    // getBase64(e.file.originFileObj, (imageUrl: string) => {
    //   // console.log(mealState.state.image);
    //   setImage(imageUrl);
    // });
    Resizer.imageFileResizer(
      e.file.originFileObj,
      400,
      400,
      `${e.file.type}`,
      100,
      0,
      uri => {
        console.log(uri);
        setImage(uri);
      },
      'base64',
      400,
      400
    );
    return e && e.fileList;
  };

  const getcurrentDateSelection = () => {
    _.forEach(mealState.state.schedule, item => {
      const newdate = new Date(item.date.seconds * 1000);
      const datetime = [{ date: newdate, time: item.time }];
      const sort = _.sortBy(datetime, ['date']);
      setscheduleValues(sort);
    });
  };
  const getStableOffer = () => {
    if (mealState.state.stableoffer !== undefined) {
      setStableOffer(mealState.state.stableoffer);
      setCheckStable(mealState.state.stableoffer.isChecked);
      return;
    }
  };

  const handleDoneSelection = (schedule: ScheduleProps[] | undefined) => {
    const sortValues = _.sortBy(schedule, ['date']);
    setscheduleValues(sortValues);
  };

  const onNumberPickerChange = (value: number | undefined) => {
    setPortions(value || 1);
  };

  const onSliderValueChange = (e: SliderValue) => {
    setSliderValue(e);
  };

  // const checker = (changedFields: any, allFields: any) => {
  //   if (changedFields.length !== 0) {
  //     if (!allFields.find((s: any) => !s.value)) {
  //       setDiasbled(false);
  //     }
  //   }
  // };

  const handleRestrictionContextChange = () => {
    const getRestrictionValues = restriction.filter(i => i.checked);
    setRestrictionValues(getRestrictionValues.map(v => v.title));
  };

  const handleStableOffer = (e: any) => {
    setCheckStable(!isChecked);
    setPopup(!isChecked);
    if (isChecked) {
      scheduleTime.forEach((item, i) => {
        const newSchedule = Object.assign({}, scheduleTime);
        newSchedule[i].active = false;
        setScheduleTime(Object.values(newSchedule));
        setStableOffer({
          isChecked: false,
          time: [],
        });
      });
    }
  };

  const displayDateList = () => {
    const result = _.chain(scheduleValues)
      .groupBy(x => moment(x.date).format('MMMM'))
      .map((v, i) => ({ month: i, date: v }))
      .value();
    return (
      <div className="datelist-container">
        {result.map((item, i) => {
          return (
            <React.Fragment key={i}>
              <span>{`${i18next.t(item.month)} ${year}`}</span>
              <div key={i} className="datelist-date-container">
                {item.date.map((d, itm) => {
                  return <div key={itm}>{moment(d.date).format('D')}</div>;
                })}
              </div>
            </React.Fragment>
          );
        })}
      </div>
    );
  };

  const onFormFinish = (values: any): void => {
    if (
      fnCheckForRestrictedWords(values.title) ||
      fnCheckForRestrictedWords(values.description)
    ) {
      Message.error(t('RESCTRICTED_MESSAGE'));
      return;
    }
    if (scheduleValues?.length === 0 && !stableOffer.isChecked) {
      Message.error(t('DATE_ERROR'));
      return;
    }

    // if (!consumption) {
    //   Message.error(t('CONSUMPTION_ERROR'));
    //   return;
    // }
    const newimage = image === mealState.state.image ? '' : image;
    const meal = {
      id: mealState.state.id,
      image: newimage,
      title: values.title,
      description: values.description,
      category,
      restrictions: restrictionValues,
      portions,
      schedule: scheduleValues,
      consumption,
      maxtime:
        consumption === EAT_WITH || consumption === BOTH ? sliderValue : 0,
      price: values.price || 0,
      stableoffer: stableOffer,
    };
    // console.log('wew', meal);
    dispatch(MealEdit(meal));
  };

  useEffect(() => {
    if (hasError) {
      Message.error(t('Something went wrong'));
      dispatch(setError(false, ''));
      return;
    }
    if (!isLoading && message) {
      Message.success(message);
      dispatch(setLoading(false, ''));
      // reset forms
      form.resetFields();
      setscheduleValues([]);
      setRestrictionValues([]);
      setCategory([]);
      setConsumption(undefined || '');
      setSliderValue(0);
      setImage('');
      setPortions(1);
      setDiasbled(true);
      resetRestriction();
    }
  }, [isLoading, message, hasError, dispatch, form, t]);
  useEffect(getcurrentDateSelection, []);
  useEffect(getStableOffer, []);
  return (
    <RestrictionContext.Provider
      value={{
        restriction,
        category: category,
        setCategory,
        handleRestrictionContextChange,
      }}
    >
      <div className="profile-container">
        <PageHeader headerTitle="Edit Offer" />
        <Row justify="center" className="add-meals-container">
          <Col
            xs={24}
            sm={24}
            md={14}
            lg={10}
            xl={10}
            className="create-meals-wrapper"
          >
            <Form
              size="middle"
              name="create-meals"
              layout="vertical"
              // onFieldsChange={checker}
              onFinish={onFormFinish}
              form={form}
              fields={fields}
            >
              <Form.Item
                name="upload"
                valuePropName="fileList"
                getValueFromEvent={normFile}
                className="create-profile-form"
                rules={[{ required: false, message: t('IMAGE_UPLOAD_ERROR') }]}
              >
                <Upload.Dragger
                  name="files"
                  className="create-meals-upload"
                  multiple={false}
                  showUploadList={false}
                >
                  <UploadPhotoContent image={image} />
                </Upload.Dragger>
              </Form.Item>
              <span style={{ color: colors.orange }}>
                Note: {t('IMAGE_NOTE')}
              </span>
              <div className="form-label">{t('General')}</div>
              <Form.Item
                name="title"
                rules={[{ required: true, message: t('FILL_TITLE') }]}
              >
                <Input placeholder={t('Name')} />
              </Form.Item>
              <Form.Item
                name="description"
                rules={[{ required: true, message: t('FILL_DESCRIPTION') }]}
              >
                <Input placeholder={t('Description')} />
              </Form.Item>

              <Form.Item>
                <Category />
              </Form.Item>

              <RestrictionsMenu />

              <div className="form-label">{t('Number of items available')}</div>
              <Form.Item className="meals-input-number">
                <InputNumber
                  value={portions}
                  min={1}
                  max={20}
                  defaultValue={1}
                  onChange={onNumberPickerChange}
                />
              </Form.Item>

              <DateSelection
                scheduleValues={scheduleValues}
                onClick={handleDoneSelection}
              />

              {scheduleValues?.length !== 0 ? displayDateList() : null}
              {/* <Form.Item>
                <Popover
                  visible={isPopup}
                  content={PopoverStableOfferContent}
                  trigger="click"
                  placement="bottomLeft"
                >
                  <Checkbox checked={isChecked} onClick={handleStableOffer}>
                    <span
                      style={{
                        fontWeight: 'bold',
                        fontSize: '15px',
                        color: '#000',
                      }}
                    >
                      {' '}
                      {t('CONSTANT_OFFER')}
                    </span>
                  </Checkbox>
                </Popover>
              </Form.Item>
              <div style={{ marginTop: '-20px' }}>
                {stableOffer.time.length > 0
                  ? stableOffer.time.map((t, i) => (
                      <div key={i} style={{ marginLeft: '30px' }}>
                        <span style={{ color: colors.green }}>
                          {'- '}
                          {i18next.t(t).toLocaleUpperCase()}
                        </span>
                      </div>
                    ))
                  : null}
              </div>
              <Form.Item>
                <Consumption
                  setConsumption={setConsumption}
                  consumption={consumption}
                />
                <React.Fragment>
                  {consumption === EAT_WITH || consumption === BOTH ? (
                    <div>
                      <div className="eatwith-description">
                        {EAT_WITH_DESCRIPTION}
                      </div>
                      <span className="form-label">{t('MAX_TIME')}</span>
                      <span className="form-label-extra">{`${sliderValue} min`}</span>
                      <Slider
                        min={10}
                        max={90}
                        step={5}
                        onChange={onSliderValueChange}
                      />
                    </div>
                  ) : null}
                </React.Fragment>
              </Form.Item>

              <div className="form-label">{t('Price per portion/item')}</div>
              <Form.Item
                name="price"
                rules={[{ required: true, message: t('FILL_PRICE') }]}
                wrapperCol={{ span: 12 }}
                labelCol={{ span: 4 }}
              >
                <div className="threshold-inner-content">
                  <Input placeholder="1.00" />
                  <span style={{ verticalAlign: 'middle' }}>Kč</span>
                </div>
              </Form.Item> */}

              <Form.Item className="form-buttons-container">
                <div className="primary-button-basic-container">
                  <Button
                    shape="round"
                    className="primary-button-basic"
                    htmlType="submit"
                    disabled={disabled}
                    loading={isLoading}
                  >
                    {t(`${message}`) || t('Edit Offer')}
                  </Button>
                </div>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </div>
    </RestrictionContext.Provider>
  );
};
